<template>
  <el-dialog title="报备查询" :visible.sync="visible" v-if="visible" width="900px" @close="close">
    <el-input placeholder="请输入搜索内容" v-model.trim="content" class="input-with-select" maxlength="50" clearable @keyup.native.enter="search" @clear="close">
      <el-select v-model="select" slot="prepend" placeholder="请选择">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-button slot="append" style="background: #108cee; color: #ffffff" icon="el-icon-search" @click="search">查询</el-button>
    </el-input>
    <div class="table-class">
      <NewTable :data="tableData" :columns="columns" :pages="pages"></NewTable>
    </div>
  </el-dialog>
</template>

<script>
import { CustomerApis } from "@/apis";
import NewTable from "@/components/new-table";
import { ReportState } from "@/utils/enum";
import Dayjs from "dayjs";

export default {
  components: { NewTable },
  data() {
    return {
      content: "",
      select: "customerName",
      visible: false,
      tableData: [],
      columns: [
        { label: "客户名称", prop: "customerName" },
        {
          label: "报备状态",
          width: "76",
          render: (h, { row }) => {
            return ReportState[row.isReport];
          },
        },
        { label: "报备到期日期", prop: "reportEndDate", width: "140" },
        { label: "报备人", prop: "reportUserName", width: "90" },
        { label: "负责人", prop: "chargeName", width: "90" },
        {
          label: "服务期内",
          width: "76",
          render: (h, { row }) => {
            return row.isServicePeriod ? "是" : "否";
          },
        },
        {
          label: "操作",
          width: "80",
          render: (h, { row }) => {
            if (!row.isReport || (row.isReport && row.isReportExpired && !row.isServicePeriod)) {
              return (
                <el-button type="primary" size="mini" onClick={() => this.reportCustomer(row)}>
                  报备
                </el-button>
              );
            }
          },
        },
      ],
      options: [
        {
          value: "customerName",
          label: "客户名",
        },
        {
          value: "linkName",
          label: "联系人",
        },
        {
          value: "linkPhone",
          label: "联系电话",
        },
      ],
      pages: {
        props: {
          pageSize: 20,
          currentPage: 1,
          total: 0,
        },
        on: {
          "current-change": this.currentChange,
          "size-change": this.sizeChange,
        },
      },
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    search() {
      if (!this.content) return this.$message.warning("请输入搜索内容");
      const query = {
        [this.select]: this.content,
        pageIndex: this.pages.props.currentPage,
        pageSize: this.pages.props.pageSize,
      };
      CustomerApis.getReportCustomer(query).then((res) => {
        this.tableData = res.data;
        this.pages.props.total = res.dataCount;
      });
    },
    async reportCustomer(row) {
      await this.$confirm("确定要报备这个客户吗？", "注意");
      const res = await CustomerApis.customerReport({ customerId: row.id });
      if (res) {
        this.$message.success("报备成功！");
        this.$emit("report", row.id);
        this.visible = false;
        this.close();
      }
    },
    sizeChange(size) {
      this.pages.props.pageSize = size;
      this.currentChange(1);
    },
    currentChange(p) {
      this.pages.props.currentPage = p;
      this.search();
    },
    close() {
      this.content = "";
      this.tableData = [];
      this.select = "customerName";
      this.pages.props.total = 0;
      this.pages.props.pageSize = 20;
      this.pages.props.currentPage = 1;
    },
  },
};
</script>

<style scoped lang="scss">
.table-class {
  height: 400px;
  display: flex;
  border: 1px solid #ebeef5;
}

.input-with-select {
  margin-bottom: 20px;

  ::v-deep .el-select .el-input {
    width: 100px;
  }
}
</style>
